import { render } from "./StepTwo.vue?vue&type=template&id=3aae3368"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\data\\work\\interfase\\crypto\\demo\\bio-web-client\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__